import React from 'react';
import PropTypes from 'prop-types';
import mergeWith from 'lodash/fp/mergeWith';
import { MENU, LANGUAGES } from 'config/types/prop';
import { ENGLISH, ENGLISH_USA } from 'config/types/language';
import moment from 'moment';
import NavItem from 'components/nav/navItem';
import I18n from 'components/i18n';

import styles from './footer.css';

const FooterNav = ({
  headingTranslation,
  heading,
  copyright,
  items,
  name,
  currentLanguage,
}) => (
  <nav className={styles[name]}>
    {heading &&
      <div className={styles.heading}>
        <I18n
          field={headingTranslation}
          defaultText={heading}
        />
      </div>
    }
    <ul>
      {copyright &&
        <li className={styles.item}>
          <span className={styles.link}>
            {`© ${moment().format('YYYY')} Babbel GmbH`}
          </span>
        </li>
      }
      {items.map((item) => {
        const translatedItem = item.translations ?
          item.translations[currentLanguage] : {};

        // Don't show entries that do not contain all necessary display data
        // NOTE: English does not use the translations object for this data, so this check isn't needed
        if (currentLanguage !== ENGLISH && currentLanguage !== ENGLISH_USA) {
          if (!translatedItem || !translatedItem.label || !translatedItem.fullUrl) { // eslint-disable-line max-len
            return null;
          }
        }

        // Normal merge isn't working here because empty
        // values are '' in the translated item
        const mergedItem = mergeWith(
          (value, source) => (!source ? value : source),
          item,
          translatedItem,
        );

        const { id, fullUrl, label } = mergedItem;
        if (!label || !fullUrl) {
          return null;
        }

        return (
          <NavItem
            isFooterLink
            itemClass={styles.item}
            linkClass={styles.link}
            key={id}
            url={fullUrl}
            label={label}
          />
        );
      })}
    </ul>
  </nav>
);

FooterNav.propTypes = {
  headingTranslation: PropTypes.string,
  heading: PropTypes.string,
  name: PropTypes.string,
  copyright: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.shape(MENU)).isRequired,
  currentLanguage: LANGUAGES,
};

FooterNav.defaultProps = {
  headingTranslation: '',
  heading: '',
  name: '',
  copyright: false,
  currentLanguage: ENGLISH,
};

export default FooterNav;
